import { useState } from "react";
import { UpdateSiteSocials } from "./Requests";
import "./Socials.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { notifyError, notifySuccess } from "../../Response/ResposeHandler";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import { useTranslation } from "react-i18next";

const Socials = (props) => {
  const { t } = useTranslation("miniSiteSocials");

  const [facebookLink, setFacebookLink] = useState(
    props.site.facebookLink === null ? null : props.site.facebookLink.replace("https://", "")
  );
  const [twitterLink, setTwitterLink] = useState(
    props.site.twitterLink === null ? null : props.site.twitterLink.replace("https://", "")
  );
  const [instagramLink, setInstagramLink] = useState(
    props.site.instagramLink === null ? null : props.site.instagramLink.replace("https://", "")
  );
  const [tiktokLink, setTiktokLink] = useState(
    props.site.tikTokLink === null ? null : props.site.tikTokLink.replace("https://", "")
  );
  const [linkedInLink, setLinkedInLink] = useState(
    props.site.linkedInLink === null ? null : props.site.linkedInLink.replace("https://", "")
  );
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);

  function SubmitSocials() {
    console.log(facebookLink)
    setSaveButtonLoading(true);
    UpdateSiteSocials(
      facebookLink === null ? null : facebookLink.replace("https://", "") === "" ? null : "https://" + facebookLink.replace("https://", ""),
      instagramLink === null ? null : "https://" + instagramLink.replace("https://", ""),
      twitterLink === null ? null : "https://" + twitterLink.replace("https://", ""),
      tiktokLink === null ? null : "https://" + tiktokLink.replace("https://", ""),
      linkedInLink === null ? null : "https://" + linkedInLink.replace("https://", "")
    )
      .then(() => {
        notifySuccess(t("toasts.saved"));
      })
      .catch(() => {
        notifyError(t("toasts.saveFailed"));
      })
      .finally(() => {
        props.getSite?.();
        setSaveButtonLoading(false);
      });
  }

  return (
    <div className="socWrap">
      <ToastContainer />

      <section className="socCard">
        <header className="socHead">
          <div className="socTitle">
            <h3>{t("titles.socialLinks")}</h3>
            <p className="socSub">{t("subtitles.addProfiles")}</p>
          </div>
        </header>

        <div className="socBody">
          <div className="socGrid">
            {/* Facebook */}
            <label className="soc-label mb-0" htmlFor="soc-fb">
              {t("fields.facebook")}
            </label>
            <div className="sm-input-affix">
              <span className="soc-inputIcon">
                <FaFacebookF />
              </span>
              <span style={{ paddingLeft: "1.8rem" }} className="sm-input-prefix" aria-hidden="true">
                https://
              </span>
              <input
                id="soc-fb"
                name="soc-fb"
                type="text"
                style={{ paddingLeft: "5.95rem" }}
                className="sm-input sm-input-with-prefix"
                placeholder={t("placeholders.facebook")}
                onChange={(e) => setFacebookLink(e.target.value)}
                value={facebookLink ?? ""}
              />
            </div>

            {/* Twitter / X */}
            <label className="soc-label mb-0 mt-1" htmlFor="soc-tw">
              {t("fields.twitterX")}
            </label>
            <div className="sm-input-affix">
              <span className="soc-inputIcon">
                <FaTwitter />
              </span>
              <span style={{ paddingLeft: "1.8rem" }} className="sm-input-prefix" aria-hidden="true">
                https://
              </span>
              <input
                id="soc-tw"
                name="soc-tw"
                type="text"
                style={{ paddingLeft: "5.95rem" }}
                className="sm-input sm-input-with-prefix"
                placeholder={t("placeholders.twitter")}
                value={twitterLink ?? ""}
                onChange={(e) => setTwitterLink(e.target.value)}
              />
            </div>

            {/* Instagram */}
            <label className="soc-label mb-0 mt-1" htmlFor="soc-ig">
              {t("fields.instagram")}
            </label>
            <div className="sm-input-affix">
              <span className="soc-inputIcon">
                <FaInstagram />
              </span>
              <span style={{ paddingLeft: "1.8rem" }} className="sm-input-prefix" aria-hidden="true">
                https://
              </span>
              <input
                id="soc-ig"
                name="soc-ig"
                type="text"
                style={{ paddingLeft: "5.95rem" }}
                className="sm-input sm-input-with-prefix"
                placeholder={t("placeholders.instagram")}
                value={instagramLink ?? ""}
                onChange={(e) => setInstagramLink(e.target.value)}
              />
            </div>

            {/* TikTok */}
            <label className="soc-label mb-0 mt-1" htmlFor="soc-tt">
              {t("fields.tiktok")}
            </label>
            <div className="sm-input-affix">
              <span className="soc-inputIcon">
                <SiTiktok />
              </span>
              <span style={{ paddingLeft: "1.8rem" }} className="sm-input-prefix" aria-hidden="true">
                https://
              </span>
              <input
                id="soc-tt"
                name="soc-tt"
                type="text"
                style={{ paddingLeft: "5.95rem" }}
                className="sm-input sm-input-with-prefix"
                placeholder={t("placeholders.tiktok")}
                value={tiktokLink ?? ""}
                onChange={(e) => setTiktokLink(e.target.value)}
              />
            </div>

            {/* LinkedIn */}
            <label className="soc-label mb-0 mt-1" htmlFor="soc-li">
              {t("fields.linkedin")}
            </label>
            <div className="sm-input-affix">
              <span className="soc-inputIcon">
                <FaLinkedinIn />
              </span>
              <span style={{ paddingLeft: "1.8rem" }} className="sm-input-prefix" aria-hidden="true">
                https://
              </span>
              <input
                id="soc-li"
                name="soc-li"
                type="text"
                style={{ paddingLeft: "5.95rem" }}
                className="sm-input sm-input-with-prefix"
                placeholder={t("placeholders.linkedin")}
                value={linkedInLink ?? ""}
                onChange={(e) => setLinkedInLink(e.target.value)}
              />
            </div>
          </div>

          <div className="socActions">
            <CustomButton
              disabled={saveButtonLoading}
              className="app-btn--sm"
              onClick={SubmitSocials}
              label={t("actions.save")}
              loading={saveButtonLoading}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Socials;
